import React from 'react';
import Hero from './Hero.js';
import OpenAccount from '../OpenAccount.js';
import Brokerage from './Brokerage.js';

function PricingPage() {
    return ( 
       <>
       <Hero/>
       <OpenAccount/>
       <Brokerage/>
       
       </>
     );
}

export default PricingPage;